import Vue from 'vue';
import Vuex from 'vuex';

import { appointment } from './store/appointment';
import { appointments } from './store/appointments';
import { checkout } from './store/checkout';
import { voucher } from './store/voucher';

import { errors } from './store/app/errors';
import { footer } from './store/app/footer';
import { google } from './store/app/google';
import { header } from './store/app/header';
import { modal } from './store/app/modal';
import { rates } from "./store/rates";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        appointment,
        appointments,
        checkout,
        voucher,
        errors,
        footer,
        google,
        header,
        modal,
        rates,
    }
});
